/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { GetOrderReportsCsvMutation, GetOrderReportsCsvMutationVariables } from "@models/graphql";

const defaultGetOrderReportsCsvOptions: MutationHookOptions<GetOrderReportsCsvMutation, GetOrderReportsCsvMutationVariables> = {};

export const useGetOrderReportsCsv = (options?: MutationHookOptions<GetOrderReportsCsvMutation, GetOrderReportsCsvMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<GetOrderReportsCsvMutation, GetOrderReportsCsvMutationVariables>(
        GraphQLDocuments.getOrderReportsCSV
    );

    const getOrderReportsCsv = async (variables: GetOrderReportsCsvMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultGetOrderReportsCsvOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        getOrderReportsCsv
    };
};
